import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { EnhancedOverview } from './running/EnhancedOverview';
import { EnhancedPerformanceAnalysis } from './running/EnhancedPerformanceAnalysis';
import { RunningTrainingLoadChart } from './running/RunningTrainingLoadChart';
import { RecordsAndPredictions } from './running/RecordsAndPredictions';
import { DataValidationPanel } from './running/DataValidationPanel';
import { AIRunSuggestion } from './running/AIRunSuggestion';
import { TrainingLoadDashboard } from '../ai-coach/TrainingLoadDashboard';

export const EnhancedRunningAnalytics: React.FC = () => {
  const [timeRange, setTimeRange] = useState('3m');
  const [activeTab, setActiveTab] = useState('overview');


  return (
    <div className="space-y-6">
      {/* Header with time range selector */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold">Enhanced Running Analytics</h1>
          <p className="text-muted-foreground">Professional-grade running performance analysis</p>
        </div>
        
        <div className="flex gap-2">
          {['1m', '3m', '6m', '1y', 'all'].map(range => (
            <Button
              key={range}
              variant={timeRange === range ? 'default' : 'outline'}
              size="sm"
              onClick={() => setTimeRange(range)}
            >
              {range === 'all' ? 'All Time' : range.toUpperCase()}
            </Button>
          ))}
        </div>
      </div>

      {/* Consolidated Analytics Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 h-auto p-2 bg-muted/50">
          <TabsTrigger value="overview" className="whitespace-normal text-center px-3 py-2 text-xs sm:text-sm">Overview</TabsTrigger>
          <TabsTrigger value="performance" className="whitespace-normal text-center px-3 py-2 text-xs sm:text-sm">Performance</TabsTrigger>
          <TabsTrigger value="training-load" className="whitespace-normal text-center px-3 py-2 text-xs sm:text-sm"><span className="sm:hidden">Load</span><span className="hidden sm:inline">Training Load</span></TabsTrigger>
          <TabsTrigger value="records" className="whitespace-normal text-center px-3 py-2 text-xs sm:text-sm"><span className="sm:hidden">Records</span><span className="hidden sm:inline">Records &amp; Predictions</span></TabsTrigger>
          <TabsTrigger value="validation" className="whitespace-normal text-center px-3 py-2 text-xs sm:text-sm">Data Quality</TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="space-y-6">
          <EnhancedOverview timeRange={timeRange} />
        </TabsContent>

        <TabsContent value="performance" className="space-y-6">
          <EnhancedPerformanceAnalysis timeRange={timeRange} />
          <RunningTrainingLoadChart timeRange={timeRange} />
        </TabsContent>

        <TabsContent value="training-load" className="space-y-6">
          <TrainingLoadDashboard timeRange={timeRange} />
        </TabsContent>

        <TabsContent value="records" className="space-y-6">
          <RecordsAndPredictions />
        </TabsContent>

        <TabsContent value="validation" className="space-y-6">
          <DataValidationPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
};